<template>
	<div class="main" v-title data-title="零部件订购记录">
		<iHeader></iHeader>
		<div class="flexRow justBetween barprebox mt25">
			<vnav></vnav>
			<div class="contR bgwhite">
				<div class="mt25 ml20">
					<div class="Ctitle">
						<h1 class="color1 font18 item1">订购记录</h1>
					</div>
				</div>

				<el-form ref="form" :model="form" label-width="80px">
					<div class="formWorder">
						<div class="w500 fl">
							<el-form-item label="订购单号">
								<el-input v-model="form.id"></el-input>
							</el-form-item>
							<el-form-item label="产品型号">
								<el-input v-model="form.xinghao"></el-input>
							</el-form-item>
							<el-form-item label="订购日期" style="width: 450px;">
								<el-date-picker v-model="form.date" type="daterange" range-separator="至" start-placeholder="开始日期"
								 end-placeholder="结束日期">
								</el-date-picker>
							</el-form-item>
							<el-form-item label="发货日期" style="width: 450px;">
								<el-date-picker v-model="form.senddate" type="daterange" range-separator="至" start-placeholder="开始日期"
								 end-placeholder="结束日期">
								</el-date-picker>
							</el-form-item>
						</div>
						<div class="fl ml20">
							<el-form-item class="w500" label="单据状态">
								<el-checkbox-group v-model="form.type">
									<el-checkbox label="待付款" name="type"></el-checkbox>
									<el-checkbox label="待生产" name="type"></el-checkbox>
									<el-checkbox label="生产中" name="type"></el-checkbox>
									<el-checkbox label="质检中" name="type"></el-checkbox>
									<el-checkbox label="待发货" name="type"></el-checkbox>
									<el-checkbox label="待收货" name="type"></el-checkbox>
									<el-checkbox label="已完成" name="type"></el-checkbox>
									<el-checkbox label="已取消" name="type"></el-checkbox>
								</el-checkbox-group>
							</el-form-item>
						</div>
					</div>

					<div class="formW center">
						<el-button type="primary" @click="onSubmit">搜索</el-button>
						<el-button>清除条件</el-button>
					</div>
				</el-form>
				<el-table :data="tableData" border style="width: 100%">
					<el-table-column prop="province" label="产品名" width="300">
					</el-table-column>
					<el-table-column prop="address" label="型号" width="300">
					</el-table-column>
					<el-table-column prop="name" label="供应商/品牌" width="120">
					</el-table-column>
					<el-table-column prop="cardid" label="询价单号" width="120">
					</el-table-column>
					<el-table-column prop="id" label="模型下载" width="120">
					</el-table-column>
					<el-table-column fixed="right" label="操作" width="100">
						<template slot-scope="scope">
							<el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>

		<v-footer></v-footer>
	</div>
</template>

<script>
	// 公共头部组件
	import iHeader from "@/components/indexheader"
	import vnav from "@/components/leftnav"
	import vFooter from "@/components/Footer"
	import VDistpicker from 'v-distpicker'
	import "@/assets/cont-01.css";
	import Vue from 'vue';
	import axios from 'axios';
	Vue.prototype.$axios = axios;
	export default {
		components: {
			iHeader,
			vFooter,
			VDistpicker,
			vnav,
		},
		data() {
			return {
				form: {
					id: '',
					xinghao: '',
					date: '',
					senddate: '',
					type: [],
				},
				titleDec: "",
				tableData: [{
					date: '2016-05-02',
					name: '王小虎',
					province: '上海',
					city: '普陀区',
					address: '上海市普陀区金沙江路 1518 弄',
					zip: 200333
				}, {
					date: '2016-05-04',
					name: '王小虎',
					province: '上海',
					city: '普陀区',
					address: '上海市普陀区金沙江路 1517 弄',
					zip: 200333
				}, {
					date: '2016-05-01',
					name: '王小虎',
					province: '上海',
					city: '普陀区',
					address: '上海市普陀区金沙江路 1519 弄',
					zip: 200333
				}, {
					date: '2016-05-03',
					name: '王小虎',
					province: '上海',
					city: '普陀区',
					address: '上海市普陀区金沙江路 1516 弄',
					zip: 200333
				}]

			};
		},
		created() {

		},
		methods: {
			handleClick(row) {
				// console.log(row);
			},
			onSubmit() {
				// console.log('submit!');
			}
		}
	}
</script>

<style scoped>
	.center {
		text-align: center;
	}

	.item1 {
		display: inline-block;
	}

	.Ctitle {
		height: 35px;
		line-height: 35px;
		vertical-align: middle;
		margin-right: 20px;
		border-bottom: 1px solid #ccc;
	}

	.formWorder {
		width: 100%;
		padding: 20px;
		box-sizing: border-box;
		height: auto;
		clear: both;
	}

	.formWorder .el-input {
		width: auto;
	}

	.w500 {
		width: 500px !important;
	}

	.fl {
		float: left;
	}

	.inputW {
		width: 200PX;
	}

	.el-input--mini .el-input__inner {
		line-height: 38PX !important;
		height: 38PX !important;
		padding-left: 10PX;
		width: 150PX;
	}

	.formWorder .el-form-item {
		margin-bottom: 22px;
		width: 353px;
		display: inline-block;
	}
</style>



// WEBPACK FOOTER //
// src/pages/people/orderrecord.vue